<template>
  <span>
    <el-button type="text" @click="firm">开始推流</el-button>
    <iframe
      id="share"
      src="https://ztxrtc.zhaotx.cn/shareStream?v=2024130"
      frameborder="0"
      align="middle"
      width="0px"
      height="0px"
      scrolling="no"
      allow="microphone; camera; display-capture;"
    ></iframe>
  </span>
</template>
<script>
export default {
  name: "SharePlayer",
  props: {
    bdId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      shareSrc: "",
    };
  },
  created(){
  },
  methods: {
    getSxtAndLive() {
        let para={
            bdId:this.bdId
        }
      this.$api
        .startPushStream(para)
        .then((res) => {
          if (res.data.meta.success) {
            var s = this.getShare();
            s.postMessage({ type: "startShare" ,liveSrc:res.data.data.zcrTldz}, "*");
          }else{
            this.$message.error(res.data.meta.message)
          }
        })
        .catch((err) => {
            this.$message.error(err.data.meta.message)
        });
    },
    getShare() {
      return document.getElementById("share").contentWindow;
    },
    firm() {
      //利用对话框返回的值 （true 或者 false）
      this.$confirm("您确定要将您的页面进行推流吗？")
        .then((res) => {
          this.getSxtAndLive()
        })
        .catch((error) => {
          console.log("取消推流");
        });
    },
    stopShare() {
      this.$confirm("您确定要关闭推流吗？")
        .then((res) => {
          var s = this.getShare();
          s.postMessage({ type: "stopShare" }, "*");
        })
        .catch((error) => {
          console.log("取消关闭推流");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>